export default __webpack_public_path__ + "modules_sm@2x.503ba46f.png";